import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ManifestService {

  private renderer: Renderer2;

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  updateManifest(name: string, shortName: string, logoUrl: string) {
    const appName = (name || 'Passbook').trim();
    const short = (shortName || appName).trim();
    const origin = window.location.origin;
    const logo = this.absoluteUrl(logoUrl);
    const icons = logo
      ? [
          { src: logo, sizes: '192x192', type: 'image/png', purpose: 'any' },
          { src: logo, sizes: '512x512', type: 'image/png', purpose: 'any' },
        ]
      : [
          { src: `${origin}/assets/icons/icon-192x192.png`, sizes: '192x192', type: 'image/png', purpose: 'any' },
          { src: `${origin}/assets/icons/icon-512x512.png`, sizes: '512x512', type: 'image/png', purpose: 'any' },
        ];

    const manifest = {
      name: appName,
      short_name: short,
      start_url: `${origin}/`,
      scope: `${origin}/`,
      id: `${origin}/`,
      display: 'standalone',
      handle_links: 'preferred',
      launch_handler: {
        client_mode: ['navigate-existing', 'auto'],
      },
      theme_color: '#ffffff',
      background_color: '#ffffff',
      icons,
    };

    const linkTag = document.querySelector('link[rel="manifest"]') as HTMLLinkElement | null;
    if (linkTag) {
      const blob = new Blob([JSON.stringify(manifest)], { type: 'application/manifest+json' });
      const manifestUrl = URL.createObjectURL(blob);
      const previousHref = linkTag.href;
      this.renderer.setAttribute(linkTag, 'href', manifestUrl);
      if (previousHref.startsWith('blob:')) {
        URL.revokeObjectURL(previousHref);
      }
    }

    this.addIosIcons(logo || logoUrl, short);
  }

  private absoluteUrl(url: string): string {
    if (!url) {
      return '';
    }
    try {
      return new URL(url, window.location.origin).href;
    } catch {
      return '';
    }
  }

  private addIosIcons(logoUrl: string, appName: string) {
    document.querySelectorAll('link[rel="apple-touch-icon"]').forEach((icon) => icon.remove());

    const sizes = ['72x72', '96x96', '128x128', '144x144', '152x152', '167x167', '180x180', '192x192', '384x384', '512x512'];
    sizes.forEach((size) => {
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'apple-touch-icon');
      this.renderer.setAttribute(link, 'sizes', size);
      this.renderer.setAttribute(link, 'href', logoUrl);
      this.renderer.appendChild(document.head, link);
    });

    this.updateIosAppTitle(appName);
  }
  
  private updateIosAppTitle(appName: string) {
    // Check if meta tag for iOS app title exists, if not, create it
    let metaTag = document.querySelector('meta[name="apple-mobile-web-app-title"]') as HTMLMetaElement;
  
    if (!metaTag) {
      metaTag = this.renderer.createElement('meta');
      this.renderer.setAttribute(metaTag, 'name', 'apple-mobile-web-app-title');
      this.renderer.appendChild(document.head, metaTag);
    }
  
    // Dynamically set the app name
    this.renderer.setAttribute(metaTag, 'content', appName);
  }
}
